import { Button, Text, TextField, Select, ButtonGroup } from '@shopify/polaris'
import React, { useState } from 'react'
import Modal from '../../../../components/Modal'
import Xero from '../../../../img/integrations/xero_icon.png'
import Google from '../../../../img/logos/google-logo.svg'


const SingUpButtons = ({countries}) => {
	const [showModal, setShowModal] = useState(false);
	React.useEffect(() => {
		if (localStorage.getItem('showGoogleModal') === 'true') {
			setShowModal(true);
			localStorage.removeItem('showGoogleModal');
		}
	}, []);
	const [companyName, setCompanyName] = useState('');
	const [countryCode, setCountryCode] = useState('');
	const [errors, setErrors] = useState({});
	
	const openModal = () => setShowModal(true);
	const closeModal = () => {
		setShowModal(false);
		setCompanyName('');
		setCountryCode('');
		setErrors({});
	};
	
	const handleModalSubmit = async () => {
		let newErrors = {};
		if (!companyName) newErrors.companyName = 'Company name is required';
		// if (!countryCode) newErrors.countryCode = 'Country is required';
		setErrors(newErrors);
		if (Object.keys(newErrors).length) return;
		// await handleGoogleLogin(companyName, countryCode);
		await handleGoogleLogin(companyName);
		closeModal();
	};
	
	const handleXeroLogin = async () => {
		const baseUrl = process.env.REACT_APP_API_URL || "";
		const isDev = baseUrl.includes('dev');
		const basicURL = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}/api/1/login/xero/`;
		
		try {
			const res1 = await fetch(basicURL, {
				method: "GET",
				mode: "cors",
			});
			
			const data = await res1.json();
			
			if (data.redict_url) {
				const redirectURL = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}${data.redict_url}`;
				window.location.href = redirectURL;
			} else {
				console.error("redict_url not found in response");
			}
		} catch (err) {
			console.error("Error during request:", err);
		}
	};
	
	const handleGoogleLogin = async (companyName, countryCode) => {
		const baseUrl = process.env.REACT_APP_API_URL || "";
		const isDev = baseUrl.includes('dev');
		const backendUrl = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}/api/1/login/google/`;
		try {
			// const params = new URLSearchParams({company_name: companyName, country_code: countryCode});
			const params = new URLSearchParams({company_name: companyName});
			const res = await fetch(`${backendUrl}?${params.toString()}`, {
				method: "GET",
				mode: "cors",
			});
			const data = await res.json();
			
			if (data.redict_url) {
				const googleAuthUrl = `${isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL}${data.redict_url}?${params.toString()}`;
				window.location.href = googleAuthUrl;
			} else {
				console.error("No redirect URL in response");
			}
		} catch (err) {
			console.error("Error fetching Google login URL:", err);
		}
	};
	
	return (
		<>
			<Modal
        title='Sign up with Google'
        visible={showModal}
        contentOnCenter
        onClose={closeModal}
        iconType={"warning"}
        description={
          <div style={{ maxWidth: 400 }}>
            <div style={{ padding: '16px 0', }}>
              <TextField
                label='Company Name'
                value={companyName}
                onChange={setCompanyName}
                error={errors.companyName}
                autoComplete='organization'
              />
	            <br/>
              {/*<Select*/}
              {/*  label='Country'*/}
              {/*  options={[*/}
              {/*    {*/}
              {/*      label: "",*/}
              {/*      value: "",*/}
              {/*    },*/}
              {/*    ...countries.map((country) => ({*/}
              {/*      label: country.name_no_article,*/}
              {/*      value: country.code,*/}
              {/*    })),*/}
              {/*  ]}*/}
              {/*  value={countryCode}*/}
              {/*  onChange={setCountryCode}*/}
              {/*  error={errors.countryCode}*/}
              {/*/>*/}
            </div>
          </div>
        }
        footer={
          <ButtonGroup fullWidth>
            <Button
              size='large'
              onClick={closeModal}
            >
              Cancel
            </Button>
            <Button
              variant={'primary'}
              size='large'
              onClick={handleModalSubmit}
            >
              Sign Up with Google
            </Button>
          </ButtonGroup>
        }
      />
		<div style={{width: '100%', marginBottom: 20}}>
        <div style={{padding: 0}}>
          <div style={{display: 'flex', flexDirection: 'row', gap: '16px', marginTop: 20}}>
            <Button
	            fullWidth
	            variant='secondary'
	            onClick={handleXeroLogin}
            >
           <img
	           src={Xero}
	           alt='Xero'
	           style={{width: 35, height: 35}}
           />
	            Sign Up with Xero
            </Button >

            <Button
	            fullWidth
	            variant='secondary'
	            onClick={openModal}
            >
	            <img
		            src={Google}
		            alt='Google'
		            style={{width: 'auto', height: 12, marginRight: 5}}
	            />
	            Sign Up with Google
            </Button >
          </div >
	        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10}}>
		        <div style={{width: '50%', height: 2, backgroundColor: 'rgb(213, 220, 224)', marginRight: 20}}></div>
	          <Text variant="headingMd" as="h2">
	            OR
	          </Text>
		        <div style={{width: '50%', height: 2, backgroundColor: 'rgb(213, 220, 224)', marginLeft: 20}}></div>
	        </div>
        </div >
    </div >
			</>
	)
}

export default SingUpButtons
